(function(algolia) {
  'use strict';
  algolia.translations = {
    ...algolia.shopify.market.translations,
    // Add additinonal translations here
    customFacetsTranslate: [
      { 'name': 'options.talla', 'translateValue': "Size"},
      { 'name': 'options.color', 'translateValue': "Color"},
      { 'name': 'price', 'translateValue': "Price"},
      { 'name': 'product_type', 'translateValue': "Type"},
      { 'name': 'new', 'translateValue': "Collection"},
      { 'name': 'named_tags.NUEVO', 'translateValue': "Collection"},
      { 'name': 'options.color', 'translateValue': "Color"},

    ],
    customCategoryTranslate: [
      // Traducciones de tipos de producto --- poner una coma al final de cada línea de traducción
{'name': 'Abrigos', 'translateValue': "Coats"},
{'name': 'Bañador Bañador', 'translateValue': "Swimsuit"},
{'name': 'Baño braguita', 'translateValue': "Braguite bath"},
{'name': 'Baño top', 'translateValue': "Top bath"},
{'name': 'Blusas', 'translateValue': "Blouses"},
{'name': 'Bolsos', 'translateValue': "Handbags"},
{'name': 'Bufandas', 'translateValue': "Scarves"},
{'name': 'Bundle', 'translateValue': "Bundle"},
{'name': 'Camisetas', 'translateValue': "Tshirts"},
{'name': 'Chalecos', 'translateValue': "Vests"},
{'name': 'Chaquetas', 'translateValue': "Jackets"},
{'name': 'Cinturones', 'translateValue': "Belts"},
{'name': 'Collares', 'translateValue': "Necklaces"},
{'name': 'Correas', 'translateValue': "straps"},
{'name': 'Cárdigans', 'translateValue': "Cardigans"},
{'name': 'Faldas', 'translateValue': "Skirts"},
{'name': 'Foulares', 'translateValue': "Fouular"},
{'name': 'Gorros', 'translateValue': "Caps"},
{'name': 'Jerséis', 'translateValue': "Sweaters"},
{'name': 'Kimonos', 'translateValue': "Kimonos"},
{'name': 'Monos', 'translateValue': "Monkeys"},
{'name': 'Pantalones', 'translateValue': "Pants"},
{'name': 'Pareos', 'translateValue': "Pareos"},
{'name': 'Pendientes', 'translateValue': "Earrings"},
{'name': 'Ponchos', 'translateValue': "Ponchos"},
{'name': 'Pulseras', 'translateValue': "Bracelets"},
{'name': 'Shorts', 'translateValue': "Shorts"},
{'name': 'Sudaderas', 'translateValue': "Sweatshirts"},
{'name': 'Tops', 'translateValue': "TOPS"},
{'name': 'Vaqueros', 'translateValue': "Cowboys"},
{'name': 'Vestidos', 'translateValue': "Dresses"},
      
      // Traducciones de color de productos --- poner una coma al final de cada línea de traducción
{'name': 'AMARILLO', 'translateValue': "YELLOW"},
{'name': 'ORO', 'translateValue': "GOLD"},
{'name': 'ANTRACITA', 'translateValue': "ANTHRACITE"},
{'name': 'AZUL', 'translateValue': "BLUE"},
{'name': 'AZUL CLARO', 'translateValue': "LIGHT BLUE"},
{'name': 'AZUL JEANS', 'translateValue': "JEANS BLUE"},
{'name': 'TURQUESA', 'translateValue': "TURQUOISE"},
{'name': 'AZUL OSCURO', 'translateValue': "DARK BLUE"},
{'name': 'AZUL MARINO', 'translateValue': "NAVY BLUE"},
{'name': 'BEIGE', 'translateValue': "BEIGE"},
{'name': 'BEIGE OSCURO', 'translateValue': "DARK BEIGE"},
{'name': 'CELESTE', 'translateValue': "SKY BLUE"},
{'name': 'CHOCOLATE', 'translateValue': "CHOCOLATE"},
{'name': 'COBRE', 'translateValue': "COPPER"},
{'name': 'BRONCE', 'translateValue': "BRONZE"},
{'name': 'CORAL', 'translateValue': "CORAL"},
{'name': 'CRUDO', 'translateValue': "RAW"},
{'name': 'TABACO', 'translateValue': "TOBACCO"},
{'name': 'TAUPE', 'translateValue': "TAUPE"},
{'name': 'FANGO', 'translateValue': "MUD"},
{'name': 'FRAMBUESA', 'translateValue': "RASPBERRY"},
{'name': 'FRESA', 'translateValue': "STRAWBERRY"},
{'name': 'FUCSIA', 'translateValue': "FUCHSIA"},
{'name': 'GRANATE', 'translateValue': "GARNET"},
{'name': 'GRIS', 'translateValue': "GREY"},
{'name': 'PLATA', 'translateValue': "SILVER"},
{'name': 'GRIS CLARO', 'translateValue': "LIGHT GREY"},
{'name': 'GRIS OSCURO', 'translateValue': "DARK GRAY"},
{'name': 'GRIS PERLA', 'translateValue': "PEARL GRAY"},
{'name': 'LAVA', 'translateValue': "WASH"},
{'name': 'LILA/MORADO', 'translateValue': "LILAC PURPLE"},
{'name': 'MORADO', 'translateValue': "PURPLE"},
{'name': 'LILA', 'translateValue': "LILAC"},
{'name': 'MARRÓN', 'translateValue': "BROWN"},
{'name': 'MARRON', 'translateValue': "BROWN"},
{'name': 'MARRÓN OSCURO', 'translateValue': "DARK BROWN"},
{'name': 'MARRON OSCURO', 'translateValue': "DARK BROWN"},
{'name': 'MOSTAZA', 'translateValue': "MUSTARD"},
{'name': 'NARANJA', 'translateValue': "ORANGE"},
{'name': 'NEGRO', 'translateValue': "BLACK"},
{'name': 'PETROLEO', 'translateValue': "PETROLEUM"},
{'name': 'ROJO', 'translateValue': "RED"},
{'name': 'BURDEOS', 'translateValue': "BORDEAUX"},
{'name': 'CEREZA', 'translateValue': "CHERRY"},
{'name': 'GRANATE', 'translateValue': "GARNET"},
{'name': 'ROSA', 'translateValue': "PINK"},
{'name': 'ROSA CLARO', 'translateValue': "LIGHT PINK"},
{'name': 'ROSA OSCURO', 'translateValue': "DARK ROSE"},
{'name': 'ROSA PALO', 'translateValue': "PINK STICK"},
{'name': 'SALMON', 'translateValue': "SALMON"},
{'name': 'TEJA', 'translateValue': "ROOF TILE"},
{'name': 'VERDE AGATA', 'translateValue': "AGATA GREEN"},
{'name': 'KAKI', 'translateValue': "KAKI"},
{'name': 'LIMA', 'translateValue': "LIME"},
{'name': 'VERDE', 'translateValue': "GREEN"},
{'name': 'VERDE AGUA', 'translateValue': "GREEN WATER"},
{'name': 'VERDE BOTELLA', 'translateValue': "GREEN BOTTLE"},
{'name': 'VERDE CLARO', 'translateValue': "LIGHT GREEN"},
{'name': 'VERDE MILITAR', 'translateValue': "MILITARY GREEN"},
{'name': 'VERDE OSCURO', 'translateValue': "DARK GREEN"},
{'name': 'VERDE PISTACHO', 'translateValue': "PISTACHIO GREEN"},
{'name': 'VERDE STONE', 'translateValue': "STONE GREEN"},
{'name': 'CAMEL', 'translateValue': "CAMEL"},
{'name': 'SALMÓN', 'translateValue': "SALMON"},
{'name': 'BLANCO', 'translateValue': "WHITE"},
      
      // Traducciones de tallas de productos --- poner una coma al final de cada línea de traducción
{'name': 'S', 'translateValue': "S"},
      
      // Traducciones de colecciones de productos (named_tags.NUEVO) --- poner una coma al final de cada línea de traducción
{'name': 'BLUSAS Y CAMISAS', 'translateValue': "Blouses and Shirts"},
{'name': 'CHALECOS', 'translateValue': "Vests"},
{'name': 'CAMISETAS', 'translateValue': "T-Shirts"},      
{'name': 'COMPLEMENTOS', 'translateValue': "Accessories"},      
{'name': 'PANTALONES', 'translateValue': "Pants"},      
{'name': 'CHAQUETAS Y KIMONOS', 'translateValue': "Jackets & Kimonos"},
{'name': 'VAQUEROS', 'translateValue': "Jeans"},
{'name': 'FALDAS', 'translateValue': "Skirts"},
{'name': 'VESTIDOS Y MONOS', 'translateValue': "Dresses and Jumpsuits"},
{'name': 'ABRIGOS', 'translateValue': "Jackets"},
{'name': 'JERSÉIS Y CÁRDIGANS', 'translateValue': "Sweaters & Cardigans"}
    ]
  };

  
  algolia.translation_helpers = {
    no_result_for: function(text) {
      return `${algolia.translations.noResultFor} " ${text} ".`;
    },
    in: function(processingTimeMS) {
      return `${algolia.translations.in} ${processingTimeMS / 1000}s`;
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ` ${ algolia.translations.outOf}`
      );
    },

    by: function(text) {
      if (!text) return '';
      return ` ${algolia.translations.by} ` + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliaShopify);
